var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployeeSuspension(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#D34829"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20.5,
    stroke: "#9097A5",
    strokeOpacity: 0.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3228_16675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5547 12.3359C16.7726 12.3359 14.5016 14.607 14.5016 17.3891C14.5016 19.1288 15.3895 20.675 16.735 21.5853C14.1601 22.6898 12.3359 25.2431 12.3359 28.2172H13.7797C13.7797 25.0193 16.3568 22.4422 19.5547 22.4422C20.548 22.4422 21.4705 22.7006 22.2834 23.1424C21.4518 24.1698 20.9982 25.4516 20.9984 26.7734C20.9984 29.954 23.5929 32.5484 26.7734 32.5484C29.954 32.5484 32.5484 29.954 32.5484 26.7734C32.5484 23.5929 29.954 20.9984 26.7734 20.9984C25.5571 21.0001 24.3724 21.3867 23.3893 22.1029C23.0702 21.9029 22.7252 21.7348 22.3743 21.5846C23.0614 21.1213 23.6242 20.4965 24.0136 19.765C24.403 19.0335 24.607 18.2177 24.6078 17.3891C24.6078 14.607 22.3368 12.3359 19.5547 12.3359ZM19.5547 13.7797C21.5564 13.7797 23.1641 15.3873 23.1641 17.3891C23.1641 19.3908 21.5564 20.9984 19.5547 20.9984C17.5529 20.9984 15.9453 19.3908 15.9453 17.3891C15.9453 15.3873 17.5529 13.7797 19.5547 13.7797ZM26.7734 22.4422C29.1744 22.4422 31.1047 24.3725 31.1047 26.7734C31.1047 29.1744 29.1744 31.1047 26.7734 31.1047C24.3725 31.1047 22.4422 29.1744 22.4422 26.7734C22.4422 24.3725 24.3725 22.4422 26.7734 22.4422ZM25.1276 24.0881L24.0881 25.1276L25.7361 26.7734L24.0902 28.4193L25.1276 29.4588L26.7734 27.8108L28.4193 29.4566L29.4588 28.4193L27.8108 26.7734L29.4566 25.1276L28.4193 24.0881L26.7734 25.7361L25.1276 24.0902V24.0881Z",
    fill: "#D34829"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3228_16675"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.1,
    height: 23.1,
    fill: "white",
    transform: "translate(9.44922 9.44922)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeSuspension);
export default __webpack_public_path__ + "static/media/employee-suspension.f5ae2b33ad2c07b41587fb873fe2c787.svg";
export { ForwardRef as ReactComponent };